import { render, staticRenderFns } from "./CustomChartManager.vue?vue&type=template&id=5311ff5e&scoped=true&"
import script from "./CustomChartManager.vue?vue&type=script&lang=js&"
export * from "./CustomChartManager.vue?vue&type=script&lang=js&"
import style0 from "./CustomChartManager.vue?vue&type=style&index=0&id=5311ff5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5311ff5e",
  null
  
)

export default component.exports